import { styled } from "@mui/system";
export const ClassicTable = styled("div")`
  table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
  }

  td,
  th {
    border: 1px solid #eff6ff;
    text-align: left;
    padding: 5px 8px;
    font-weight: bold;
  }

  th {
    background-color: #eff6ff;
  }
`;
